import * as React from 'react';

import { cn } from '../../../lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[96px] w-full resize-none rounded-md border-2 border-transparent bg-control px-2 py-1 text-sm text-control-foreground transition-colors placeholder:text-input-placeholder focus-visible:border-focus focus-visible:outline-none aria-[invalid=true]:border-control-border-error aria-[invalid=true]:focus-visible:border-focus disabled:cursor-not-allowed disabled:bg-control-disabled disabled:text-control-disabled-foreground',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
